var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-row',{attrs:{"gutter":20}},[_c('a-col',{attrs:{"span":24}},[_vm._v(" 切换系统 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }